// extracted by mini-css-extract-plugin
module.exports = {"productImages":"mS0yET","productImageWrapper":"TOKEYp","productImage":"BAxQUR","productBadge":"ASDFqi"};